import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { requestLoginWlWithToken } from '../../store/modules/auth/actions';
import Animation from '../../components/common/animation';
import { searchToObject } from '../../utils/locationSearchToObject';

export default function Auth() {
  const dispatch = useDispatch();
  const history = useHistory();
  const wlState = useSelector((state) => state?.whitelabel);

  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const isWl = wlState?.config?.is_white_label;
    const wlLoginUrl = wlState?.config?.login_url;

    try {
      if (!isWl) {
        throw new Error('unauthorized');
      }

      const { token, customer_id } = searchToObject();
      const successFn = () => {
        // redireciona para tela de chat somente quando o login for feito com sucesso
        history.push('/chat');
      };
      // redireciona para tela de login quando o login for feito com erro
      const errorFn = () => {
        if (wlLoginUrl) {
          // retorna para a tela de login do wl
          window.location.href = wlLoginUrl;
        } else {
          history.push('/login');
        }
      };
      dispatch(requestLoginWlWithToken(token, customer_id, successFn, errorFn));
    } catch (err) {
      setLoading(false);
      setNotFound(true);
    }
  }, [wlState]);

  return (
    <>
      {loading && (
        <div className="auth-wrapper">
          <Animation
            icon="loading"
            size={40}
            style={{
              border: '4px solid transparent',
              borderColor: '#ced4da',
              borderTopColor: '#6c757d',
            }}
          />
        </div>
      )}

      {notFound && (
        <div className="auth-wrapper">
          Ops! A página que voce está tentando acessar não existe!
        </div>
      )}
    </>
  );
}
